interface BookingInsightTableProps {
  headers: string[]
  data: any[][]
}

const renderRow = (data: any[][]) => data.map((d) => (
  <tr key={d[0]} className="border border-stroke-subtle">
    {
      d.map((td, index) => (
        <td key={td} className={`text-jsm font-medium py-4 ${index === 0? 'pl-6' : ''}`}>{td}</td>
      ))
    }
  </tr>
))

const BookingInsightTable: React.FC<BookingInsightTableProps>
  = ({data, headers}) => (
  <div className="w-full border border-stroke-subtle rounded overflow-hidden">
    <table className="w-full">
      <thead>
      <tr className="bg-grey-subtle text-grey-dark">
        {
          headers.map((header, index) => (
            <th key={header} className={`${index === 0 ? 'pl-6' : ''}`}>
              {header}
            </th>
          ))
        }
      </tr>
      </thead>
      <tbody>
      {renderRow(data)}
      </tbody>
    </table>
  </div>
)

export default BookingInsightTable;